<template>
  <div class="container-galeria">
    <Galleria
      :value="images"
      :activeIndex.sync="activeIndex"
      :responsiveOptions="responsiveOptions"
      :numVisible="7"
      :containerStyle="getMaxWidth"
      :circular="true"
      :fullScreen="true"
      :showItemNavigators="true"
      :showThumbnails="true"
      :visible.sync="displayCustom"
    >
      <template #item="slotProps">
        <img
          :src="slotProps.item.itemImageSrc"
          :alt="slotProps.item.texto"
          style="width: 100%; display: block;"
        />
      </template>
      <template #thumbnail="slotProps">
        <img
          :src="slotProps.item.thumbnailImageSrc"
          :alt="slotProps.item.texto"
          style="display: block;"
        />
      </template>
    </Galleria>
    <div
      v-for="(image, index) of images"
      :key="index"
      class="container-img"
    >
      <img
        :src="image.thumbnailImageSrc"
        :alt="image.texto"
        style="cursor: pointer"
        @click="imageClick(index)"
        class="image"
      />
      <h2 class="text" @click="imageClick(index)" v-if="showLabel">
        {{ $t(image.texto).toUpperCase() }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "Galeria",
  props: {
    images: {
      type: Array,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      responsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 5,
        },
        {
          breakpoint: "768px",
          numVisible: 3,
        },
        {
          breakpoint: "560px",
          numVisible: 1,
        },
      ],
      responsiveOptions2: [
        {
          breakpoint: "1500px",
          numVisible: 5,
        },
        {
          breakpoint: "1024px",
          numVisible: 3,
        },
        {
          breakpoint: "768px",
          numVisible: 2,
        },
        {
          breakpoint: "560px",
          numVisible: 1,
        },
      ],
      displayBasic: false,
      displayBasic2: false,
      displayCustom: false,
    };
  },
  methods: {
    imageClick(index) {
      this.activeIndex = index;
      this.displayCustom = true;
    },
  },
  computed: {
    getMaxWidth() {
      if(window.innerWidth>800){
        return "max-width: 850px"      
      }      
      return "max-width: 400px"
    },
  },
};
</script>

<style scoped>
.container-img {
  position: relative;
  width: 173px;
  height: 173px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: rgb(76, 152, 252);
  margin: 10px;
  border-radius: 5px;
}
.text {
  font-size: 14px;
  letter-spacing: 1.2px;
  color: white;
  margin: 0;
  position: absolute;
  display: none;
  transition: 0.9s all;
  user-select: none;
  cursor: pointer;
  text-align: center;
}

.image {
  height: 100%;
  -webkit-transition: all 0.9s ease; /* Safari y Chrome */
  -moz-transition: all 0.9s ease; /* Firefox */
  -o-transition: all 0.9s ease; /* IE 9 */
  -ms-transition: all 0.9s ease; /* Opera */
  border-radius: 5px;
  overflow: hidden;
}
.container-img:hover .image {
  -webkit-transform: scale(1.25);
  -moz-transform: scale(1.25);
  -ms-transform: scale(1.25);
  -o-transform: scale(1.25);
  transform: scale(1.25);
  opacity: 0.8;
  border-radius: 5px;
}
.container-img:hover .text {
  display: block;
  border-radius: 5px;
}

.container-galeria {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.container-panel {
  width: 100%;
}

@media screen and (max-width: 880px) {  
  .container-img {
    width: 100%;
    height: auto;
    margin: 10px;
    background:none;
  }
  .text {
    font-size: 20px;
  }
  .title {
    font-size: 35px;
  }
}
</style>
